import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import {
  Box,
  Button,
  Container,
  Stack,
  Tab,
  useMediaQuery,
  useTheme,
  Link,
  Grid
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import BasicBreadcrumbs from "../../components/breadcrumb";

import toast from "react-hot-toast";
import FormEvent from "./formEvent";
import FormEmployee from "./formEmployee1";
import EmployeeList from "./employeeList";
import DetailsEventForm from "./detailsEventForm";
import { useLocation, useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import { useApiClient } from "../../context/ApiClientContext";
import ErrorAlert from "../../helper/errorAlert";
import dayjs from "dayjs";
import api from "../../helper/baseApi";
import ActivityListing from "../../components/activityListing";
import ViewDetails from "./viewDetails";
// import FormEmployee from "./formEmployee"

export const DataContext = React.createContext();

const EventContainer = () => {
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = React.useState();
  const [pageSize, setPageSize] = React.useState();
  const [filteredDataList, setFilteredDataList] = React.useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [inputForm, setInputForm] = useState([]);

  const { apiUrls: { mobileApiUrl } } = useApiClient();

  const activities = {
    today: [
      {
        email: "yp.loo@gosumgroup.com",
        action: "submit mission",
        time: "2 hours ago",
      },
      {
        email: "yp.loo@gosumgroup.com",
        action: "open the mission",
        time: "6 hours ago",
      },
      {
        email: "naja@gosumgroup.com",
        action: "liked the mission",
        time: "8 hours ago",
      },
      {
        email: "naja@gosumgroup.com",
        action: "open the mission",
        time: "12 hours ago",
        image: "https://picsum.photos/60/40?1",
      },
    ],
    thisWeek: [
      {
        email: "zixin.chen@gosumgroup.com",
        action: "assign the mission to nurin@gosumgroup.com",
        time: "4 days ago",
        image: "https://picsum.photos/60/40?3",
      },
      {
        email: "zixin.chen@gosumgroup.com",
        action: "assign the mission to naja@gosumgroup.com",
        time: "4 days ago",
        image: "https://picsum.photos/60/40?3",
      },
      {
        email: "zixin.chen@gosumgroup.com",
        action: "create this mission",
        time: "5 days ago",
        image: "https://picsum.photos/60/40?4",
      },
    ],
  };

  if (typeof id === "object" && id !== null) {
    console.log("ID is an object, keys:", Object.keys(id));
    console.log("ID object content:", id);
  }

  useEffect(() => {
    fetchData();
  }, [location.pathname]);

  const fetchData = async (page) => {
    try {
      const apiUrl = `${mobileApiUrl}event/event-details-portal?eventId=${id}`;
      const response = await api.get(apiUrl);
      if (response.data) {
        const eventData = response.data.data;
        setInputForm({
          title: eventData.title || "",
          description: eventData.description || "",
          startDate: eventData.eventDate ? dayjs(eventData.eventDate).format('YYYY-MM-DD') : "",
          endDate: eventData.completedDate ? dayjs(eventData.completedDate).format('YYYY-MM-DD') : "",
          publishedDate: eventData.publishDate ? dayjs(eventData.publishDate).format('YYYY-MM-DD') : "",
          venue: eventData.eventVenue || "",
          status: eventData.status || "",
          createdBy: eventData.creatorName || "",
          createdDate: eventData.createdDate ? dayjs(eventData.createdDate).format('YYYY-MM-DD') : "",
        });
      }
    } catch (error) {
      ErrorAlert(error, navigate);
    }
  };

  // const event = eventData.find((u) => u.id === Number(id));

  return (
    <PrivateLayout>
      <Box sx={{ mx: 4, mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            // mb: 3,
          }}
        >
          <Box display="flex" justifyContent="start" alignItems="center">
            <BasicBreadcrumbs
              first={
                <Link component={RouterLink} to="/event" underline="hover" color="primary.main">
                  Event Announcement
                </Link>
              }
              second="View" />

            <Box sx={{ display: "flex" }}></Box>
          </Box>
        </Box>
        <Grid container spacing={8} mb={3}>
          {/* <Grid item mt={1} size={{ xs: 12, md: 5 }}>
            <ActivityListing activities={activities} />
          </Grid> */}
          <Grid item size={{ xs: 12 }}>
            <Box display="flex" justifyContent="flex-end" backgroundColor="white" p={2} borderRadius={2} boxShadow={3} mt={2}>

              <ViewDetails id={id} eventList={inputForm} />
            </Box>
          </Grid>
        </Grid>
      </Box>

    </PrivateLayout>
  );
};

export default EventContainer;
